import { createFileRoute } from "@tanstack/react-router"
import CoreSupportRequestsPage from "@/components/coreSupportRequests/CoreSupportRequestsPage"

export const Route = createFileRoute("/core/support-requests/")({
  component: CoreSupportRequestsPage
})
